import React from 'react';
import { BaseConfig } from '../BaseConfig';
import ContnueButton from '../ui/ContinueButton';
import { UIProperties } from '../UIProperties';

import './GeneralAlert.css'
import { GeneralButtonConfig } from './GeneralButton';

const GeneralAlert = (props: UIProperties<GeneralAlertConfig>) => {
	return (
		<div className="in-game-ui-container ui-top-most-container">
			<div className="alert-container center-on-container" tabIndex={0} id="general-alert-ui-first" aria-label={'alert'}>
				<img src="./assets/images/general/backgrounds/alert-background-v1.png"/>
				{props.parameters.smallerTitle ? 
				(<p className="alert-title title-font" style={{fontSize: '16pt'}} tabIndex={0}>{props.parameters.title}</p>) : 
				(<p className="alert-title title-font" tabIndex={0}>{props.parameters.title}</p>)}
				<div className="alert-desc-container">
					<div className="alert-desc-left">
						<img className="center-on-container" src={props.parameters.img}/>
					</div>
					{props.parameters.useBigText ? (
						<div className="alert-desc-right" style={{
							width: '464px',
							position: 'absolute',
							height: '245px',
							right: '10px'
						}}>
							<p className="alert-desc big-description-font" style={{
								position: 'absolute',
								top: '50%',
								left: '0',
								transform: 'translate(0, -50%)',
								margin: 0
							}} tabIndex={0}>{props.parameters.text}</p>
							<ContnueButton parameters= {{
								id:"general-alert-ui-last",
								top: '171px',
								left: '100px',
								width: '190px',
								onClicked: props.parameters.onContinueClicked
							}}/>
						</div>
					) : (
						<div className="alert-desc-right" style={{
							width: '464px',
							position: 'absolute',
							height: '245px',
							right: '10px'
						}}>
							<div style={{
								height: '157px',
								margin: '10px',
								position: 'relative'
							}}>
								<p className="alert-desc regular-description-font" style={{
									position: 'absolute',
									top: '0',
									left: '0',
									transform: 'translate(0, 0)',
									margin: 0
								}} tabIndex={0}>{props.parameters.text}</p>
							</div>

							<ContnueButton parameters= {{
								id:"general-alert-ui-last",
								top: '265px',
								left: '100px',
								width: '190px',
								onClicked: props.parameters.onContinueClicked
							}}/>
						</div>
					)}
				</div>
			</div>
		</div>
	);

};

export interface GeneralAlertConfig extends BaseConfig {
	title: string;
	text: string;
	smallerTitle?: boolean;
	useBigText?: boolean;
	img: string;
	onContinueClicked: () => void;
}

export default GeneralAlert;